<template>
  <div class="block">
    <div class="block-header">
      <div class="header-info">
        <h4 class="block-header-title is-size-4">
          <slot name="header">Default Header</slot>
        </h4>
        <p class="is-marginless is-size-7">
          <slot name="subheader"></slot>
        </p>
      </div>
      <div class="actions">
        <slot name="actions"></slot>
      </div>
    </div>
    <div class="totals-per-type">
      <div class="total-item">
        <span class="total-pendientes" style="font-size: 1.5rem; margin-right: -3px;">{{
          totalPending
        }}</span>
        <img class="icon icon-svg" src="@/static/svg/icono_pendiente_v2.svg" alt="pendiente" />
      </div>

      <div class="total-item">
        <span class="total-completados" style="font-size: 1.5rem; margin-right: -3px;">{{
          totalCompleted
        }}</span>
        <img class="icon icon-svg" src="@/static/svg/icono_check_v2.svg" alt="completado" />
      </div>

      <div class="total-item">
        <span class="total-fallidos" style="font-size: 1.5rem; margin-right: -3px;">{{
          totalFailed
        }}</span>
        <img class="icon icon-svg" src="@/static/svg/icono_nocheck_v2.svg" alt="fallido" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    borderedHeader: {
      type: Boolean,
      default: false
    },
    totalPending: {
      type: Number,
      required: true
    },
    totalFailed: {
      type: Number,
      required: true
    },
    totalCompleted: {
      type: Number,
      required: true
    }
  },

  computed: {
    hasActions() {
      return !!this.$slots.actions
    },
    hasHeader() {
      return !!this.$slots.header
    }
  }
}
</script>

<style scoped>
.block {
  background: white;
  padding: 12px 25px !important;
}

.block-header {
  padding-bottom: 7px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.block-header-title {
  padding: 0;
  margin: 0;
  font-weight: 500;
  color: #333 !important;
}

.total-pendientes {
  color: #ffa500;
}

.total-completados,
.total-fallidos {
  color: grey;
}

.totals-per-type {
  display: flex;
  justify-content: flex-start;
  width: 35%;

  font-size: 20px;
  font-weight: bold;
}

.icon-svg {
  margin-right: 19px;
  top: -3px;
  height: 1.15rem;
  width: auto;
}
</style>
